// Lazily load pdf.js from a CDN (same approach as loadLeaflet in components/CompMap.jsx) so the
// template builder can render PDF pages to canvas without adding a bundler dependency. The UMD build
// exposes window.pdfjsLib; we point its worker at the matching CDN file. Memoized so repeated calls
// share one load.
let pdfjsLoading = null;
const PDFJS_VERSION = '3.11.174';
const BASE = `https://cdnjs.cloudflare.com/ajax/libs/pdf.js/${PDFJS_VERSION}`;

export function loadPdfJs() {
  if (window.pdfjsLib) return Promise.resolve(window.pdfjsLib);
  if (pdfjsLoading) return pdfjsLoading;
  pdfjsLoading = new Promise((resolve, reject) => {
    const script = document.createElement('script');
    script.src = `${BASE}/pdf.min.js`;
    script.onload = () => {
      const lib = window.pdfjsLib;
      if (!lib) { reject(new Error('pdf.js failed to load')); return; }
      // The worker must be set or multi-page rendering stalls.
      lib.GlobalWorkerOptions.workerSrc = `${BASE}/pdf.worker.min.js`;
      resolve(lib);
    };
    script.onerror = () => reject(new Error('Could not load pdf.js from CDN'));
    document.head.appendChild(script);
  });
  return pdfjsLoading;
}
